<template>
    <div>
        <base-button-icon
            @click="openHelp"
            icon-name="help"
            :button-text="$t('HELP')"
        />

        <base-modal
            @modalClose="showModal = false"
            :show-modal="showModal"
            modal-position="center"
        >
            <template v-slot:closeButton>
                <close-button
                    @click="handleCloseModal"
                    class="absolute top-[28px] right-4"
                    width="16"
                />
            </template>
            <template v-slot:content>
                <div class="mb-2 text-[16px] font-semibold">
                    {{ $t('NEED_HELP') }}
                </div>

                <div class="mb-[34px] text-[16px] leading-snug">
                    {{ $t('NEED_HELP_COPY') }}
                </div>

                <div class="mb-2 text-[16px] font-semibold">
                    {{ $t('CALL') }}
                </div>

                <div class="mb-2 leading-snug">
                    {{ $t('CALL_COPY_1') }}&nbsp;
                    <a :href="`tel:${ $t('TITLEIST_PHONE_NUMBER') }`"
                        :class="[
                            'text-red underline',
                            'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
                        ]"
                    >
                        {{ $t('TITLEIST_PHONE_NUMBER') }}
                    </a>
                </div>
                <div class="mb-2 leading-snug">
                    {{ $t('CALL_COPY_2') }}
                    <span class="uppercase">
                        {{ $t('TITLEIST_OPEN_HOURS') }}
                    </span>
                </div>

                <div class="w-full border border-gray-DFDFDF my-3" />

                <div class="mb-2 text-[16px] font-semibold capitalize">
                    {{ $t('EMAIL') }}
                </div>

                <div class="mb-2 leading-snugext-lg leading-snug">
                    {{ $t('EMAIL_COPY_1') }}
                    <a
                        :class="[
                            'text-red underline',
                            'focus:outline-none focus:ring-1 focus:ring-black focus:border-black ring-offset-2',
                        ]"
                        :href="$t('EMAIL_URL')"
                        target="_blank"
                    >
                        {{ $t('EMAIL') }}
                    </a>
                    {{ $t('EMAIL_COPY_2') }}&nbsp;
                </div>

            </template>
        </base-modal>
    </div>
</template>

<script>
    import BaseButtonIcon from './BaseButtonIcon.vue';
    import BaseModal from '../BaseModal.vue';
    import CloseButton from './CloseButton.vue';

    export default {
        components: {
            BaseButtonIcon,
            BaseModal,
            CloseButton,
        },

        data() {
            return {
                showModal: false,
            };
        },

        methods: {
            openHelp() {
                this.showModal = true;
            },
            handleCloseModal() {
                this.showModal = false;
            },
        },
    };
</script>
